var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.situacao)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({class:("pb-1 " + _vm.textColorClass),attrs:{"right":_vm.iconInRight}},on),[_vm._v(" mdi-circle-medium ")])]}}],null,false,3942938321)},[_c('span',[_vm._v(_vm._s(_vm.description))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }